var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg012Delete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "34px",
    viewBox: "0 0 26 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "trash") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Select-FAV-Location-Copy-25_Outline-Copy-Copy",
    transform: "translate(-167.000000, -215.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(24.000000, 201.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(125.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trash",
    transform: "translate(18.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2488FF",
    points: "23.1111111 2.88888889 20.2222222 2.88888889 18.7777778 0 7.22222222 0 5.77777778 2.88888889 2.88888889 2.88888889 2.88888889 5.77777778 23.1111111 5.77777778"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FF3051",
    points: "2.88888889 5.77777778 0 5.77777778 0 9.97979798 2.88888889 9.97979798 23.1111111 9.97979798 26 9.97979798 26 5.77777778 23.1111111 5.77777778"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFCD00",
    points: "2.88888889 9.97979798 2.88888889 30.2020202 2.88888889 33.0909091 23.1111111 33.0909091 23.1111111 9.97979798"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(7.353535, 13.656566)",
    fill: "#FF5023"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.77777778,15.7575758 C6.1766501,15.7575758 6.5,15.4368982 6.5,15.0413223 L6.5,0.716253444 C6.5,0.32067759 6.1766501,0 5.77777778,0 C5.37890546,0 5.05555556,0.32067759 5.05555556,0.716253444 L5.05555556,15.0413223 C5.05555556,15.4368982 5.37890546,15.7575758 5.77777778,15.7575758 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8333333,15.7575758 C11.2322057,15.7575758 11.5555556,15.4368982 11.5555556,15.0413223 L11.5555556,0.716253444 C11.5555556,0.32067759 11.2322057,0 10.8333333,0 C10.434461,0 10.1111111,0.32067759 10.1111111,0.716253444 L10.1111111,15.0413223 C10.1111111,15.4368982 10.434461,15.7575758 10.8333333,15.7575758 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.722222222,15.7575758 C1.12109454,15.7575758 1.44444444,15.4368982 1.44444444,15.0413223 L1.44444444,0.716253444 C1.44444444,0.32067759 1.12109454,0 0.722222222,0 C0.323349903,0 0,0.32067759 0,0.716253444 L0,15.0413223 C0,15.4368982 0.323349903,15.7575758 0.722222222,15.7575758 Z",
    id: "Path"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg012Delete);
export default __webpack_public_path__ + "static/media/012-delete.9ba7ecc703fcad65537b930fc269be3b.svg";
export { ForwardRef as ReactComponent };